var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"password-rules text-small text-muted",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.text))}}):_c('span',{attrs:{"data-role":"hint","data-hint-text":_vm.$t(_vm.text),"data-cls-hint":"drop-shadow"}},[_c('span',{staticClass:"mif-help1 mif-1x"})])
}
var staticRenderFns = []

export { render, staticRenderFns }